import React, { useCallback } from "react";

function Input({
    value,
    placeholder,
    label,
    onChange,
    isValid = true,
    error
}) {
    const handleInputChange = useCallback((event) => {
        onChange(event.target.value);
    }, []);
    return (
        <div>
            <div className="text-[10px] md:text-xs leading-3 text-[#A4AAAC] dark:text-white/[0.5] py-2">{label}</div>
            <input
                value={value}
                onChange={handleInputChange}
                className={`text-[13px] leading-4 w-full bg-white rounded-lg px-3 py-2 dark:bg-[#1A222D] text-[#353A3C] dark:text-white ${isValid ? 'border-[#404749]/[0.15] dark:border-[#9fafc5]/[0.2]' : 'focus:border-[#FFB69F] border-[#FFB69F] focus:dark:border-[#EB7D3F] dark:border-[#EB7D3F]'} focus:ring-0`}
                type="text"
                placeholder={placeholder}
            />
            {!isValid && <p className="mt-2 text-[10px] md:text-xs leading-[13px] text-[#FF5C00] dark:text-[#EB7D3F]">{error}</p>}
        </div>
    );
}

export default Input;
